import React, { useRef } from 'react';
import { Lock as LockIcon } from '@mui/icons-material';
import clsx from 'clsx';

import noPreviewImage from '../../../../../../images/NoPreview.png';
import noPreviewReelImage from '../../../../../../images/StoriesNoPreview.png';

const MediaThumbnail = ({ content, blocked, onClick }) => {
  const img = useRef();

  const onImageLoadError = () => {
    if (img?.current) {
      if (content?.type === 'reel') {
        img.current.src = noPreviewReelImage;
      } else {
        img.current.src = noPreviewImage;
      }
    }
  };

  return (
    <>
      <div
        className={clsx('media-thumbnail-container', { 'cursor-pointer': !blocked })}
        onClick={() => {
          onClick();
        }}>
        <img src={content.thumbnail} alt="" className="media-image" onError={onImageLoadError} ref={img} />
        {blocked && (
          <div className="media-thumbnail-blocked-container">
            <LockIcon
              style={{
                width: '20px',
                height: '20px',
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default MediaThumbnail;
